<template>
  <q-dialog :visible="isVisible" :title="title" width="1000px" @close="onCancel" :innerScroll="false"
    :loading="loadingBtn" @cancel="onCancel" @confirm="onConfirm">
    <div class="unable-listing-container">
      <div class="table-title">{{ rowData.itemName }}审核人配置</div>
      <el-table :data="tableData" border size="mini">
        <el-table-column label="节点名称" width="120" align="center">
          <template slot-scope="{row}">
            <el-input v-model="row.nodeName" v-if="row.nodeName != '质检审核'" />
            <span v-else>{{ row.nodeName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="是否关联店铺" width="150" align="center">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.relationStore" size="mini" v-if="scope.row.nodeName != '质检审核'">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>

        <el-table-column label="区分兼职/全职" width="150" align="center">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.jobTime" size="mini" v-if="scope.row.nodeName != '质检审核' && scope.row.relationStore == 1">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>

        <el-table-column label="操作人" align="left">
          <template slot-scope="{row, $index}">
            <el-select v-model="row.userIds" filterable remote multiple collapse-tags placeholder="请输入关键词"
              :remote-method="(query) => remoteMethod(query, $index)" :loading="loading" size="mini"
              @change="handleUserChange($index)">
              <el-option v-for="item in row.userList || []" :key="item.userId"
                :label="`${item.userName}-${item.workNo}`" :value="item.userId">
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="顺序" width="80" align="center">
          <template slot-scope="{row}">
            <el-input v-model="row.sortNum" v-if="row.nodeName != '质检审核'" @input="sortNumInput(row)" />
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.nodeName !== '质检审核'">
              <el-button type="text" size="mini" style="color: #f56c6c" @click="deleteRow(scope.$index)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增按钮放在表格下方 -->
      <div class="add-row-container">
        <el-button type="text" @click="addNewRow" class="add-row-btn">
          <i class="el-icon-plus"></i> 添加1行
        </el-button>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';

export default {
  name: 'UnableListing',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return !!this.rowData ? '编辑' : '新增';
    }
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      tableData: [
        {
          relationStore: 1,
          jobTime: 1,
          userIds: [],
          userList: []
        },
        {
          relationStore: 1,
          jobTime: 1,
          userIds: [],
          userList: []
        },
        {
          relationStore: 1,
          jobTime: 1,
          userIds: [],
          userList: []
        }
      ],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  mounted() {
    this.tableData = this.rowData.items || []
    this.tableData.forEach(v => {
      v.userIds = v.userIds.map(v => v + '')
      v.itemName = this.rowData.itemName
    })
    // 添加回显逻辑
    this.initUserData();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      // 先进行表单验证
      if (!this.validateTableData()) {
        return;
      }
      
      let data = this.tableData.map(v => {
        return {
          ...v,
          userIds: v.userIds.map(v => +v)
        }
      })
      // 验证和保存逻辑
      this.loadingBtn = true;
      this.$q.qualityTestingManage
        .qualityAuditConfigSave({ data: data })
        .then((res) => {
          if (res.success) {
            this.$message.success('编辑成功');
            this.$emit('success');
            this.onCancel();
          } else {
            this.$message.error(res.message || '操作失败');
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    validateTableData() {
      // 验证除最后一行外的所有行
      for (let i = 0; i < this.tableData.length - 1; i++) {
        const row = this.tableData[i];
        // 跳过质检审核行的验证
        if (row.nodeName === '质检审核') {
          continue;
        }
        
        if (!row.nodeName) {
          this.$message.error('节点名称不能为空');
          return false;
        }
        
        if (!row.userIds || row.userIds.length === 0) {
          this.$message.error(`操作人不能为空`);
          return false;
        }
        
        if (!row.sortNum) {
          this.$message.error(`顺序不能为空`);
          return false;
        }
      }
      
      return true;
    },
    addNewRow() {
      const newRow = {
        nodeName: '',
        relationStore: 0,
        jobTime: 0,
        userIds: [],
        userList: [],
        sortNum: '',
        itemName: this.rowData.itemName
      };
      this.tableData.splice(this.tableData.length - 1, 0, newRow);
    },
    deleteRow(index) {
      this.tableData.splice(index, 1);
    },
    sortNumInput(row) {
      // 只允许输入正整数且不能为0
      row.sortNum = row.sortNum.replace(/[^\d]/g, ''); // 只保留数字
      if (row.sortNum.startsWith('0')) {
        row.sortNum = row.sortNum.replace(/^0+/, ''); // 去除前导0
      }
      if (row.sortNum === '' || row.sortNum === '0') {
        row.sortNum = '';
      }
    },
    remoteMethod(query, index) {
      // 当没有搜索词时，显示当前已选中的用户集合
      let ids = !query ? this.tableData[index].userIds || [] : [];

      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = 'searchUserInfoByName';
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
        userId: ids || [],
      };

      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.$set(this.tableData[index], 'userList', res.data.list);
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    handleUserChange(index) {
      // 处理多选用户变化
      const selectedUserIds = this.tableData[index].userIds || [];
      const selectedUsers = this.tableData[index].userList.filter(user =>
        selectedUserIds.includes(user.userId)
      );

      if (selectedUsers.length > 0) {
        // 更新选中用户的信息
        this.$set(this.tableData[index], 'selectedUsers', selectedUsers);
        this.$set(this.tableData[index], 'userName', selectedUsers.map(u => u.userName).join(','));
        this.$set(this.tableData[index], 'workNo', selectedUsers.map(u => u.workNo).join(','));
      }
    },
    async initUserData() {
      // 为每行有userIds的数据初始化用户信息
      for (let i = 0; i < this.tableData.length; i++) {
        const row = this.tableData[i];
        if (row.userIds && Array.isArray(row.userIds) && row.userIds.length > 0) {
          if (row.userName) {
            // 如果已有用户名，构造userList用于显示
            const userNames = row.userName.split(',');
            const workNos = (row.workNo || '').split(',');
            const userList = row.userIds.map((userId, idx) => ({
              userId: userId,
              userName: userNames[idx] || '',
              workNo: workNos[idx] || ''
            }));
            this.$set(this.tableData[i], 'userList', userList);
          } else {
            // 如果只有userIds，需要查询用户信息
            await this.getUserInfo(row.userIds, i);
          }
        }
      }
    },

    async getUserInfo(userIds, index) {
      try {
        let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
        currencyForm.reportCode = 'searchUserInfoByName';
        currencyForm.pageSize = 100;
        currencyForm.param = {
          userName: "",
          userId: userIds, // 传递数组
        };
        const res = await axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm);
        if (res.code == 200 && res.data.list && res.data.list.length > 0) {
          this.$set(this.tableData[index], 'userList', res.data.list);
          // this.$set(this.tableData[index], 'userName', res.data.list.map(u => u.userName).join(','));
          // this.$set(this.tableData[index], 'workNo', res.data.list.map(u => u.workNo).join(','));
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.unable-listing-container
  max-height: 70vh
  overflow-y: auto
  padding: 0px

.table-title
  font-size: 14px
  font-weight: bold
  margin-bottom: 15px

>>> .el-table th
  background-color: #f5f7fa !important

>>> .el-radio-group
  display: flex
  justify-content: center

>>> .el-radio
  margin-right: 10px !important

>>> .el-dialog 
  margin: 50px auto !important

.el-icon-plus {
  font-size: 18px
  border: 2px solid #0BB78E
  border-radius: 4px
  padding-right: 0px
  cursor: pointer
}

>>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 100% !important;
  }

</style>
